import React from 'react';
import { Text } from '@qga/roo-ui/components';

import Skeleton from '@shared/v2/components/Skeleton';
import ToggleContent from '@shared/v2/components/ToggleContent';

import LinkButton from '@/components/LinkButton';
import RoomInformationModal from '@/components/RoomInformationModal';
import { RoomType } from '@/v2/services/availability/types/api/parsedResponse';

export type DetailsButtonProps = {
  roomType: RoomType;
};

const DetailsButton = ({ roomType }: DetailsButtonProps) => {
  return (
    <ToggleContent
      toggle={(show) => (
        <Skeleton width="115px" height="1.25rem" mt="4">
          {/* @ts-ignore - bad JS type */}
          <LinkButton mt="2" noPadding fontSize="sm" onClick={() => show()}>
            <Text textDecoration="underline" lineHeight="1.5" fontSize="sm">
              View room details
            </Text>
          </LinkButton>
        </Skeleton>
      )}
      content={(close) => (
        // @ts-ignore (TS battling with different function types from JS)
        <RoomInformationModal close={close} roomType={roomType} />
      )}
    />
  );
};

export default DetailsButton;
